export default __webpack_public_path__ + "static/date-label-anatomy-dark-33bba12deb7f5532177ec3b47f0b1f18.png";